import React, { useState } from 'react';
import {
  AppBar,
  makeStyles,
  Toolbar,
  Menu,
  MenuItem,
  Divider,
  ListItemIcon,
  Button
} from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { localeSelector } from 'redux/selectors';
import { FormattedMessage } from 'react-intl';
import { changeLocale } from 'redux/actions/language';
import { drawerWidth, drawerCloseWidth } from '../NavBar'
import PropTypes from 'prop-types';
import SelectLanguage from 'components/SelectLanguage';

export const topbar_height = 80

const useStyles = makeStyles(theme => ({
  appBar: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    height: topbar_height,
    minHeight: 'auto',
    boxShadow: 'none',
    borderBottom: '1px solid #D3DAF7',
    transition: 'all .5s ease'
  },
  toolbar: {
    flex: 1,
    alignItems: 'center',
    paddingLeft: '2%',
    paddingRight: '2%',
    backgroundColor: '#F2F5FB',
    minHeight: 'unset !important'
  },
  logo: {
    height: 30,
  },
  divider: {
    width: 1,
    backgroundColor: '#868aa8',
    height: '40%',
    margin: '0 5px',
  },
  name: { whiteSpace: 'nowrap', color: '#868aa8' },
  middle: {
    whiteSpace: 'nowrap',
    color: '#868aa8',
    flex: 1,
    textAlign: 'center',
    fontWeight: 'bold',
    padding: theme.spacing(1, 0)
  },
  middleLogo: {
    height: 30,
  },
  avatar: {
    width: 32,
    height: 32,
    fontSize: 14,
    backgroundColor: theme.palette.text.primary,
  },
  lng: {
    width: 32,
    height: 32,
    fontSize: 14,
    backgroundColor: theme.palette.app.primary,
  },
  langBtn: {
    color: 'white',
    border: `2px solid white`,
    borderRadius: 10,
    padding: `2px 5px`,
    marginBottom: 6,
    minWidth: 'unset',
    fontSize: 15,
    fontWeight: 'bold'
  },
  clientBtn: {
    borderRadius: theme.spacing(1),
    padding: '6px 20px',
    marginRight: theme.spacing(2)
  },
  clientBtnLabel: {
    textTransform: 'none'
  },
  indicator: {
    width: 65,
    height: 5,
    backgroundColor: '#6CB570',
    borderRadius: 10,
    marginRight: 'auto',
    marginLeft: 'auto',
    marginTop: 4
  },
  tabButton: {
    backgroundColor: 'white',
    color: theme.palette.app.primary,
    borderRadius: '0px !important',
    marginLeft: 35,
    marginRight: 35,
    transitionDuration: '0s !important',
    '&:hover': {
      backgroundColor: 'white',
    },
  },
  InactivetabButton: {
    color: 'white',
    borderRadius: '0px !important',
    marginLeft: 35,
    marginRight: 35,
    transitionDuration: '0s !important',
    '&:hover': {
      backgroundColor: 'transparent',
      color: 'white',
    },
  },
  logoleft: {
    position: 'absolute',
    top: 0,
    height: '100%',
    right: '100%'
  },
  logoright: {
    position: 'absolute',
    top: 0,
    height: '100%',
    left: '100%'
  },
  logomiddle: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    left: 0,
    top: 0
  },
  iconbutton: {
    color: theme.palette.text.primary,
    margin: theme.spacing(0, 2),
    fontWeight: '600',
    textTransform: 'none'
  },
  btnIcon: {
    fill: theme.palette.app.primary,
    width: 20,
    height: 20
  },
  badge: {
    backgroundColor: theme.palette.app.primary,
    color: 'white',
    right: 5,
    fontSize: 8,
    top: 17,
    width: 16,
    height: 16,
    minWidth: 16
  },
  iconWrap: {
    width: 35,
    height: 35,
    backgroundColor: 'white',
    borderRadius: 50,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  langRoot: {
    zIndex: "10001 !important"
  }
}));

const TopBar = ({ openDrawer }) => {
  const classes = useStyles();

  return (
    <AppBar
      elevation={0}
      position="fixed"
      color="default"
      className={classes.appBar}
      style={!openDrawer ? {
        marginLeft: drawerCloseWidth,
        width: `calc(100% - ${drawerCloseWidth}px)`
      } : {}}
    >
      <Toolbar className={classes.toolbar}>
        <div className={classes.middle}>
        </div>
        <div>
          <SelectLanguage buttonStyle={"top_lang"}/>
        </div>
      </Toolbar>
    </AppBar>
  );
};

TopBar.propTypes = {
  openDrawer: PropTypes.any,
};

export default TopBar;
